import { StateCreator } from "zustand";
import { BreadcrumbItem, Language } from "../../generated-api/account";

export type GeneralSlice = {
  theme: "light" | "dark";
  languageSettings: Language;
  showMenu: boolean;
  activePath: BreadcrumbItem[];
  loginHint: string;
  showAppStoreFeature: boolean;
  activeMenuId: string | undefined;
  navigationWidth: number;
  setActivePath: (path: BreadcrumbItem[]) => void;
  setTheme: (theme: "light" | "dark") => void;
  setLoginHint: (hint: string) => void;
  setLanguageSettings: (language: Language) => void;
  setShowMenu: (show: boolean) => void;
  setShowAppStoreFeature: (show: boolean) => void;
  setActiveMenuId: (id?: string) => void;
  setNavigationWidth: (width: number) => void;
};

export const generateInitialState = {
  theme: "dark",
  languageSettings: {
    id: "8c183644-6730-ea11-a601-281878e92c65",
    languageName: "English (Great Britain)",
    localLanguageName: "English",
    code: "ENU",
    alternateCode: "ENU",
    iso639Code: "en-GB",
    iso6391: "en",
  },
  showMenu: true,
  showAppStoreFeature: false,
  activePath: [] as BreadcrumbItem[],
  loginHint: "",
  activeMenuId: undefined,
  navigationWidth: 320,
} as GeneralSlice;

export const createGeneralSlice: StateCreator<
  GeneralSlice,
  [],
  [],
  GeneralSlice
> = (set) =>
  ({
    ...generateInitialState,
    setActivePath: (path: BreadcrumbItem[]) => {
      set(() => {
        return {
          activePath: path,
        };
      });
    },
    setTheme: (theme: "light" | "dark") => {
      set(() => {
        return {
          theme,
        };
      });
    },
    setLoginHint: (hint: string) => {
      set(() => {
        return {
          loginHint: hint,
        };
      });
    },
    setLanguageSettings: (languageSettings: Language) => {
      set(() => {
        return {
          languageSettings,
        };
      });
    },
    setShowMenu: (show: boolean) => {
      set(() => {
        return {
          showMenu: show,
        };
      });
    },
    setActiveMenuId: (id?: string) => {
      set(() => {
        return {
          activeMenuId: id,
        };
      });
    },
    setShowAppStoreFeature: (show: boolean) => {
      set(() => {
        return {
          showAppStoreFeature: show,
        };
      });
    },
    setNavigationWidth: (width: number) => {
      set(() => {
        return {
          navigationWidth: width,
        };
      });
    },
  }) as GeneralSlice;
